"use client"

import { useAuthorHover } from "@/components/ArticleContent/components/Byline/context/byline-context"
import { EmailLink } from "@/components/Link/EmailLink/EmailLink.component"
import { Translation } from "@/components/Translation/Translation.component"
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types"

type AuthorListProps = {
  readonly authors: ReadonlyArray<ArticleContentModel.Author>
}

export function AuthorList({ authors }: AuthorListProps) {
  const { hoveredAuthorIndex, handleMouseEnter, handleMouseLeave } =
    useAuthorHover()

  return (
    <span className="inline-block font-theme-bold text-primary text-sm uppercase">
      {authors.map((author: ArticleContentModel.Author, index: number) => {
        const { email, fullName } = author
        const isLast = index === authors.length - 1

        return (
          <span key={email || fullName}>
            {index > 0 && (isLast ? " " : ", ")}
            {isLast && authors.length > 1 && (
              <>
                <Translation da="og" de="und" en="and" no="og" sv="och" />{" "}
              </>
            )}
            {email ? (
              <EmailLink
                className={`transition-all duration-150 hover:underline ${
                  hoveredAuthorIndex === index ? "underline" : ""
                }`}
                emailAddress={email}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                position={`bl-mto-${index}`}
              >
                {fullName}
              </EmailLink>
            ) : (
              fullName
            )}
          </span>
        )
      })}
    </span>
  )
}
